import { render, staticRenderFns } from "./ErrorColum.vue?vue&type=template&id=47aad368&scoped=true"
import script from "./ErrorColum.vue?vue&type=script&lang=js"
export * from "./ErrorColum.vue?vue&type=script&lang=js"
import style0 from "./ErrorColum.vue?vue&type=style&index=0&id=47aad368&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aad368",
  null
  
)

export default component.exports